
import React from 'react';
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';
import { useContext } from 'react';
import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Polyline, Popup, Circle, Rectangle, Polygon, useMapEvent, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});



const ShowMapProposal = () => {
    const context = useContext(AdminContext);
    const { id, technicalID } = useParams();
    const { CreateMapCoordinateforProposal } = context;
    const nav = useNavigate();

    const [FetchedCoordinates, setFetchedCoordinates] = useState([]);
    const [Creator, setCreator] = useState("");
    const [mapCenter, setMapCenter] = useState([18.5615, 73.7685]);
    const [typeofConstruction, setTypeofConstruction] = useState("");
    const [clickPositions, setClickPositions] = useState([]);







    const fetchCoordinatesfromtable = async () => {
        try {
            let res = await CreateMapCoordinateforProposal("FetchSpecificCoordinatefromTableforProposal", id);
            console.log(res);
            setFetchedCoordinates(res);
            setTypeofConstruction(res[0]?.ConstructionType);
            setCreator(res[0]?.createdBy);
            setClickPositions(res[0])

            if (res && res.length > 0) {
                const firstPolygon = res[0].Area;
                if (firstPolygon && firstPolygon.length > 0) {
                    setMapCenter(firstPolygon[0]);
                }
            }
        }
        catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        fetchCoordinatesfromtable();
    }, []);




    const FlyToCenter = ({ center }) => {
        const map = useMap();
        useEffect(() => {
            if (center) {
                map.flyTo(center, 14); // Zoom to level 17
            }
        }, [center, map]);
        return null;
    }


    const SatelliteLayerSwitcher = () => {
        const [isSatellite, setIsSatellite] = useState(false);
        const map = useMapEvents({
            zoomend: () => {
                const zoom = map.getZoom();
                setIsSatellite(zoom >= 17); // Use satellite when zoom >= 17
            }
        });

        return (
            <>
                {!isSatellite && (
                    <TileLayer
                        attribution='&copy; OpenStreetMap contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        maxZoom={22}
                    />
                )}
                {isSatellite && (
                    <TileLayer
                        attribution="Map data &copy; Google"
                        url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
                        maxZoom={22}
                    />
                )}
            </>
        );
    };


    const handleBack = () => {
        console.log(Creator);
        if (Creator == "State") {
            nav(`/AdminDashboard/ProposalInwardStateWise`);
        }
        else {
            nav(`/AdminDashboard/ProposalInwardsList`);
        }
    }


    return (
        <>


            <div style={{ height: '500px', width: '100%' }}>
                <MapContainer center={mapCenter} zoom={15} style={{ height: '100%', width: '100%' }}>
                    <SatelliteLayerSwitcher />
                    <FlyToCenter center={mapCenter} />

                    {FetchedCoordinates &&
                        FetchedCoordinates.map((pos, idx) => (
                            <React.Fragment key={idx}>
                                <Marker position={pos.StartCoordinates}>
                                    <Popup>
                                        <strong>Start Point</strong><br />
                                        Construction : {pos.ProposalID}<br />
                                        Lat: {pos.StartCoordinates[0]}<br />
                                        Lng: {pos.StartCoordinates[1]}
                                    </Popup>
                                </Marker>

                                <Marker position={pos.EndCoordinates}>
                                    <Popup>
                                        <strong>End Point</strong><br />
                                        Type: {pos.ConstructionType}<br />
                                        Lat: {pos.EndCoordinates[0]}<br />
                                        Lng: {pos.EndCoordinates[1]}
                                    </Popup>
                                </Marker>
                            </React.Fragment>
                        ))
                    }

                    {FetchedCoordinates &&
                        FetchedCoordinates.map((val, index) => {
                            const color =
                                val.ConstructionType === "Road" ? "green" :
                                    val.ConstructionType === "Metro" ? "red" :
                                        val.ConstructionType === "Water" ? "aqua" :
                                            val.ConstructionType === "Drainage" ? "brown" :
                                                "blue"; // default

                            const dashArray = val.ConstructionType === "Drainage" ? "2,6" :
                                val.ConstructionType === "Metro" ? "10,10" : undefined;

                            return (
                                <Polygon
                                    key={index}
                                    positions={val.Area}
                                    pathOptions={{
                                        color,
                                        weight: 2,
                                        fillOpacity: 0.6,
                                        dashArray,
                                    }}
                                >
                                    <Popup>
                                        <strong>Proposal Name:</strong> {val.ProposalID}
                                        <br />
                                        <strong>Construction Type:{val.ConstructionType} Line</strong><br />
                                    </Popup>
                                </Polygon>
                            );
                        })
                    }

                    {/* {clickPositions.length === 2 && (
                        <>
                            <Polyline positions={clickPositions} color="blue" />
                            <Polygon
                                positions={polygonPositions}
                                pathOptions={{ color: 'green', weight: 2, fillOpacity: 0.4 }}
                            >
                                <Popup>Assigning</Popup>
                            </Polygon>
                        </>
                    )} */}
                </MapContainer>



                <div className="col-12 text-center mt-4">
                    {/* <button className='btn btn-success px-4 mx-4' onClick={() => SubmitCoordinateSelected()}>Submit</button> */}
                    <button className='btn btn-danger px-4 mx-4' onClick={()=>handleBack()}>Go Back</button>
                </div>
            </div>



        </>
    )
}

export default ShowMapProposal;